module.exports = __webpack_public_path__ + "static/media/FinanceBrokerIcon.448763be.svg";